export const TAGS = {
  div: 'div',
  a: 'a',
  nuxtLink: 'NuxtLink'
}
